import _ from 'lodash'
import { storeToRefs } from "pinia";
import { useSearchPageStore } from "@/stores/searchPageStore.js";

const numericContextFilters = [
  { icon: 'equal', operator: '=' },
  { icon: 'notequal', operator: '<>' },
  { icon: 'less', operator: '<' },
  { icon: 'greater', operator: '>' },
  { icon: 'lessorequal', operator: '<=' },
  { icon: 'greaterorequal', operator: '>=' }
]

const filterColumnValue = (column, operator, value) => {
  const searchPageStore = useSearchPageStore()
  const { headerFilter } = storeToRefs(searchPageStore)

  let _headerFilter = headerFilter.value ? JSON.parse(JSON.stringify(headerFilter.value)) : null
  const newFilter = [column, operator, value]
  // if we have no filter this becomes the filter
  if (_.isEmpty(_headerFilter)) {
    _headerFilter = newFilter
  }
  // if there is only one filter then the entire headerFilter is that filter
  // eg. ['State', 'contains', 'TX']
  else if (_headerFilter[0].constructor.name === 'String') {
    if (_headerFilter[0] === column)
      _headerFilter = newFilter
    else
      _headerFilter = [_headerFilter, 'and', newFilter]
  }
  // otherwise, replace the existing filter for this column or add this onto the end
  else {
    const existingIndex = _headerFilter.findIndex(val => val[0] === column )
    if (existingIndex && existingIndex !== -1)
      _headerFilter.splice(existingIndex, 1, newFilter)
    else
      _headerFilter = [..._headerFilter, 'and', newFilter]
  }
  headerFilter.value = _headerFilter
}

const excludeColumnValue = (column, value) => {
  const searchPageStore = useSearchPageStore()
  const { headerFilter } = storeToRefs(searchPageStore)

  let _headerFilter = headerFilter.value ? JSON.parse(JSON.stringify(headerFilter.value)) : null
  const newFilter = [column, '<>', value]
  // if we have no filter this becomes the filter
  if (_.isEmpty(_headerFilter)) {
    _headerFilter = newFilter
  }
  // if there is only one filter then the entire headerFilter is that filter
  // eg. ['State', 'contains', 'TX']
  // this excludeColumnValue() differs from filterColumnValue() because of the "noneof" operator which allows a list of exclusions
  else if (_headerFilter[0].constructor.name === 'String') {
    if (_headerFilter[0] === column && (_headerFilter[1] === '<>' || _headerFilter[1] === 'noneof')) {
      if (_headerFilter[1] === 'noneof')
        _headerFilter[2].push(value)
      else
        _headerFilter.splice(1, 2, 'noneof', [_headerFilter[2], value])
    }
    else
      _headerFilter = [_headerFilter, 'and', newFilter]
  }
  // otherwise, replace the existing filter for this column or add this onto the end
  else {
    const existingIndex = _headerFilter && _headerFilter.findIndex(val => val[0] === column )
    if (existingIndex && existingIndex !== -1)
      if (_headerFilter[existingIndex][1] === 'noneof')
        _headerFilter[existingIndex][2].push(value)
      else
        _headerFilter[existingIndex].splice(1, 2, 'noneof', [_headerFilter[existingIndex][2], value])
    else
      _headerFilter = [..._headerFilter, 'and', newFilter]
  }
  headerFilter.value = _headerFilter
}

export const addContextMenuItems = (e) => {
  let items = e.items || []

  // items for only the header
  if (e.row.rowType === 'header') {
    // renaming some columns
    _.find(items, item => { return item.text === 'Set Fixed Position' }).text = 'Pin Column'
    _.find(items, item => { return item.text === 'Unfix' }).text = 'Unpin Column'
  }
  // items for clicking on a cell in the grid
  else if (e.row.rowType === 'data') {
    const colName = e.column.name
    let cellVal = e.row.cells[e.columnIndex].value

    if (cellVal === null || (cellVal.constructor.name === 'String' && cellVal.trim() === '')) {
      cellVal = null
      items.push(
        {text: `Filter (Blank)`, onItemClick: () => filterColumnValue(colName, '=', cellVal)},
        {text: `Exclude (Blank)`, onItemClick: () => excludeColumnValue(colName, cellVal)}
      )
    }
    else if (e.column.dataField === 'doc_title') {
      let splitDocPath = cellVal.split('/')
      if (splitDocPath.length === 1)
        items.push({ text: `Filter ${cellVal}` })
      else {
        let pathItems = []
        for (let i = 1; i <= splitDocPath.length; i++) {
          let currentPath = splitDocPath.slice(0, i).join('/')
          pathItems.push({
            text: `${currentPath}${ i < splitDocPath.length ? '/...' : ''}`,
            onItemClick: () => filterColumnValue(colName, 'startswith', currentPath)
          })
        }
        items.push({ text: `Filter...`, items: pathItems })
      }
    }
    else if (e.column.dataType === 'date') {
      items.push(
        {
          text: `Filter...`,
          items: numericContextFilters.map(filterOptions => {
            return {
              icon: filterOptions.icon,
              text: cellVal.toLocaleString('en-US', {year: 'numeric', month: 'numeric', day: 'numeric'}),
              onItemClick: () => filterColumnValue(colName, filterOptions.operator, cellVal)
            }
          })
        })
    }
    else if (e.column.dataType === 'number') {
      items.push({
        text: `Filter...`,
        items: numericContextFilters.map( filterOptions => {
          return {
            icon: filterOptions.icon,
            text: cellVal,
            onItemClick: () => filterColumnValue(colName, filterOptions.operator, cellVal)
          }
        })
      })
    }
    else {
      items.push(
        {text: `Filter ${cellVal}`, onItemClick: () => filterColumnValue(colName, '=', cellVal)},
        {text: `Exclude ${cellVal}`, onItemClick: () => excludeColumnValue(colName, cellVal)}
      )
    }
  }
  e.items = items
}
